
import { commonfunc } from '~/mixin/common'

export default {
  name: 'BannerUnit',
  mixins: [commonfunc],
  props: {
    banrLinkMvmnTyCd: {
      type: String,
      default: ''
    },
    pcomLinkUrl: {
      type: String,
      default: ''
    },
    banrRplcTextNm: {
      type: String,
      default: ''
    },
    pcomIconAtchFileUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    clickBanner (banrLinkMvmnTyCd, pcomLinkUrl) {
      console.log('banrLinkMvmnTyCd ===', banrLinkMvmnTyCd)
      if (banrLinkMvmnTyCd === '02') {
        window.open(pcomLinkUrl)
      } else {
        this.$router.push(pcomLinkUrl)
      }
    },
  }
}
